<template>
  <!-- 蒙版背景 v-if="visible" -->
  <div class="alert-mask" @click.self="closeIfClickMask">
    <!-- 弹窗主体 -->
    <div class="alert-modal" :style="modalStyle">
      <!-- 红色头部 -->
      <div class="alert-header" :style="{ backgroundColor: alertTypeColor }">
        <div class="alert-icon">
          <svg width="24" height="24" viewBox="0 0 24 24">
            <path fill="white" d="M12 2L1 21h22L12 2zm0 5l7 12H5l7-12z"/>
            <rect fill="white" x="11" y="9" width="2" height="6" rx="1"/>
            <circle fill="white" cx="12" cy="18" r="1.5"/>
          </svg>
        </div>
        <div class="alert-title">{{ alertTitle }}</div>
        <div class="close-btn" @click="close">×</div>
      </div>

      <!-- 告警内容 -->
      <div class="alert-body">
        <div class="alert-item" v-for="(item, index) in alertInfo" :key="index">
          <div class="item-label">{{ item.label }}</div>
          <div class="item-value" :class="{'highlight': item.highlight}">
            {{ item.value }}
            <span v-if="item.unit">{{ item.unit }}</span>
          </div>
        </div>
      </div>

      <!-- 操作按钮 -->
      <div class="alert-footer">
        <button class="action-btn ignore">忽略</button>
        <button class="action-btn confirm" :style="{ backgroundColor: alertTypeColor }">
          处理告警
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, computed, ref } from 'vue'

const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  alertData: {
    type: Object,
    default: () => ({
      title: '数据阈值上限告警',
      type: 'warning', // warning | danger | info
      info: [
        { label: '设备名称', value: '烟感探测器', highlight: true },
        { label: '设备编号', value: '100001', highlight: false },
        { label: '报警时间', value: '2025-07-20 10:03:36', highlight: false },
        { label: '报警类型', value: '烟雾浓度超标', highlight: true },
        { label: '位置', value: '北京市怀柔区', highlight: true },
        { label: '当前值', value: 86.5, unit: 'ppm', highlight: true },
        { label: '阈值上限', value: 60, unit: 'ppm', highlight: true }
      ]
    })
  },
  clickMaskClose: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['close', 'confirm', 'ignore'])

// 根据告警类型确定颜色
const alertTypeColor = computed(() => {
  switch (props.alertData.type) {
    case 'warning': return '#FF9800'
    case 'info': return '#2196F3'
    default: return '#F44336' // 默认为红色警报
  }
})

const alertTitle = computed(() => props.alertData.title || '系统告警')
const alertInfo = computed(() => props.alertData.info || [])

// 弹窗尺寸样式
const modalStyle = ref({
  width: '520px',
  borderRadius: '8px',
  boxShadow: '0 8px 24px rgba(244, 67, 54, 0.25)'
})

function close() {
  emit('close')
}

function closeIfClickMask() {
  if (props.clickMaskClose) close()
}

function confirm() {
  emit('confirm')
}

function ignore() {
  emit('ignore')
}
</script>

<style scoped>
/* 蒙版样式 */
.alert-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.65);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(2px);
}

/* 弹窗主体 */
.alert-modal {
  background-color: white;
  overflow: hidden;
  animation: modalEnter 0.3s ease-out;
}

@keyframes modalEnter {
  0% {
    opacity: 0;
    transform: translateY(-20px) scale(0.95);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* 弹窗头部 */
.alert-header {
  padding: 16px 24px;
  display: flex;
  align-items: center;
  color: white;
  font-weight: 600;
  position: relative;
}

.alert-icon {
  margin-right: 12px;
  display: flex;
  align-items: center;
}

.alert-title {
  font-size: 18px;
  flex: 1;
}

.close-btn {
  font-size: 24px;
  cursor: pointer;
  padding: 0 8px;
  line-height: 1;
  transition: transform 0.2s;
}

.close-btn:hover {
  transform: scale(1.2);
}

/* 告警内容 */
.alert-body {
  padding: 24px;
  max-height: 60vh;
  overflow-y: auto;
}

.alert-item {
  display: flex;
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #f0f0f0;
  font-size: 14px;
}

.alert-item:last-child {
  margin-bottom: 0;
  padding-bottom: 0;
  border-bottom: none;
}

.item-label {
  width: 100px;
  color: #666;
}

.item-value {
  flex: 1;
  color: #333;
  font-weight: 500;
}

.item-value.highlight {
  color: #F44336;
  font-weight: 600;
}

/* 底部按钮 */
.alert-footer {
  padding: 16px 24px;
  display: flex;
  justify-content: flex-end;
  gap: 16px;
}

.action-btn {
  padding: 8px 24px;
  border-radius: 4px;
  font-weight: 500;
  cursor: pointer;
  border: none;
  transition: all 0.2s;
}

.action-btn.ignore {
  background: #f5f5f5;
  color: #666;
}

.action-btn.ignore:hover {
  background: #eaeaea;
}

.action-btn.confirm {
  color: white;
}

.action-btn:hover {
  opacity: 0.9;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
</style>